function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _require = require('preact'),
    h = _require.h,
    Component = _require.Component;

var RecordButton = require('./RecordButton');

var SubmitButton = require('./SubmitButton');

var StopWatch = require('./StopWatch');

var StreamStatus = require('./StreamStatus');

var RecorderScreen = /*#__PURE__*/function (_Component) {
  _inherits(RecorderScreen, _Component);

  var _super = _createSuper(RecorderScreen);

  function RecorderScreen() {
    _classCallCheck(this, RecorderScreen);

    return _super.apply(this, arguments);
  }

  _createClass(RecorderScreen, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onStop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          recording = _this$props.recording,
          videoStream = _this$props.stream,
          recordedVideo = _this$props.recordedVideo;
      var videoProps = {
        playsinline: true
      }; // show stream

      if (recording || !recordedVideo && !recording) {
        videoProps.muted = true;
        videoProps.autoplay = true;
        videoProps.srcObject = videoStream;
      } // show preview


      if (recordedVideo && !recording) {
        videoProps.muted = false;
        videoProps.controls = true;
        videoProps.src = recordedVideo; // reset srcObject in dom. If not resetted, stream sticks in element

        if (this.videoElement) {
          this.videoElement.srcObject = undefined;
        }
      }

      return h("div", {
        className: "uppy uppy-ScreenCapture-container"
      }, h("div", {
        className: "uppy-ScreenCapture-videoContainer"
      }, h(StreamStatus, this.props), h("video", _extends({
        ref: function ref(videoElement) {
          _this.videoElement = videoElement;
        },
        className: "uppy-ScreenCapture-video"
      }, videoProps)), h(StopWatch, this.props)), h("div", {
        className: "uppy-ScreenCapture-buttonContainer"
      }, h(RecordButton, this.props), h(SubmitButton, this.props)));
    }
  }]);

  return RecorderScreen;
}(Component);

module.exports = RecorderScreen;